import { PASSWORD_RESET } from 'common/messages';
import templateUrl from './reset-password-frompin.html';

export default {
  templateUrl,
  bindings: {
    credentials: '<'
  },
  controller: class ResetPasswordFromPinComponent {
    constructor($state, ResetPasswordFromPinService, ToastService) {
      'ngInject';

      Object.assign(this, { $state, ResetPasswordFromPinService, ToastService });
    }

    $onInit() {
      this.resetErrorMessages();
    }

    resetErrorMessages() {
      this.invalidUsername = false;
      this.invalidNewPassword = false;
      this.invalidPIN = false;
      this.expiredPIN = false;
    }

    onSubmit() {
      this.invalidUsername = false;
      this.invalidNewPassword = false;
      this.invalidPIN = false;
      this.expiredPIN = false;
      this.ResetPasswordFromPinService.changePasswordFromPin({
        ...this.credentials
      }).then(() => {
        this.ToastService.showSuccess(PASSWORD_RESET);
        this.$state.go('login');
      }).catch((error) => {
        if (error && error.data && error.data.Message) {
          if (error.data.Message === 'Invalid New Password') {
            this.invalidNewPassword = true;
          } else if (error.data.Message === 'Invalid PIN') {
            this.invalidPIN = true;
          } else if (error.data.Message === 'Expired PIN') {
            this.expiredPIN = true;
          }
        } else if (error && error.statusText === 'Not Found') {
          this.invalidUsername = true;
        } else {
          this.ToastService.showError(error);
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./components/auth/reset-password-frompin/reset-password-frompin.component.js